module.exports = __webpack_public_path__ + "img/zhyly-9.444a8250.png";